import React from "react";
import { Link } from "react-router";
import { Route } from "static-route-paths";
import { useHcpSpecificMessagingDispatch, useHcpSpecificMessagingState } from "../../data/hcpSpecificMessaging/hooks";
import { usePrintMessages } from "../../data/messages/context";
import { useClientTranslation } from "../../hooks/useClientTranslation";
import PageHeader from "../Headers/PageHeader";
import SearchBox from "../SearchBox/SearchBox";

interface MessagePageHeaderProps {
  client: string;
  path: Route;
  children?: React.JSX.Element | React.JSX.Element[];
  isPrint?: boolean;
}

const MessagePageHeader: React.FC<MessagePageHeaderProps> = ({ client, path, children, isPrint = true }) => {
  const { filters } = useHcpSpecificMessagingState();
  const { updateGenericFilter } = useHcpSpecificMessagingDispatch();
  const [, { setExpandedHCPProvider }] = usePrintMessages();

  const getClientTranslation = useClientTranslation();
  const printPortalTitle = getClientTranslation("messages.costAndCoveragePrintPortal", client);
  const emailPortalTitle = getClientTranslation("email.costAndCoverageEmailPortal", client);

  return (
    <PageHeader title={isPrint ? printPortalTitle : emailPortalTitle}>
      <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3">
        <SearchBox
          value={filters.genericFilter}
          handleChange={(value) => {
            updateGenericFilter(value);
            setExpandedHCPProvider(null);
          }}
        />
        {children && (
          <Link to={path.with({ client })} className="btn btn-primary">
            {children}
          </Link>
        )}
      </div>
    </PageHeader>
  );
};

export default MessagePageHeader;
